import { Container } from '@material-ui/core'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import Attendance from './Attendance'

import Home from './Home.jsx'
import { useAuthContext } from './contexts/AuthContext'
import Error from './Error'
import OnlineClass from './OnlineClass'
import BottomNav from './partials/BottomNav'
import Profile from './Profile'
import { navDirections } from './utils/navDirections'
import ProtectedRoute from './utils/ProtectedRoute'
import OnlineClassSubjects from './OnlineClassSubjects'
import OnlineClassChapters from './OnlineClassChapters'
import OnlineClassYtVideo from './OnlineClassYtVideo'
import Login from './Login.jsx'
import ContactUs from './ContactUs'
import Exams from './Exams'
import ExamInstructions from './ExamInstructions'
import ExamPage from './ExamPage'
import Results from './Results'
import ExamInstantResult from './ExamInstantResult'
import RankList from './RankList'
import Timetable from './Timetable'
import Announcements from './Announcements'

function Main() {
    const { user } = useAuthContext()

    return (
        <Router>
            <Container maxWidth="md">
                <Switch>
                    <ProtectedRoute
                        exact
                        path={navDirections.HOME}
                        component={Home}
                    />
                    <Route exact path={navDirections.LOGIN} component={Login} />
                    <ProtectedRoute
                        exact
                        path={navDirections.MY_PROFILE}
                        component={Profile}
                    />
                    <ProtectedRoute
                        exact
                        path={navDirections.ONLINE_CLASS}
                        component={OnlineClass}
                    />
                    <ProtectedRoute
                        exact
                        path={navDirections.ONLINE_CLASS_SUBJECT}
                        component={OnlineClassSubjects}
                    />
                    <ProtectedRoute
                        exact
                        path={navDirections.ONLINE_CLASS_CHAPTERS}
                        component={OnlineClassChapters}
                    />
                    <ProtectedRoute
                        exact
                        path={navDirections.ONLINE_CLASS_VIDEO}
                        component={OnlineClassYtVideo}
                    />
                    <ProtectedRoute
                        exact
                        path={navDirections.EXAMS}
                        component={Exams}
                    />
                    <ProtectedRoute
                        exact
                        path={navDirections.EXAMS_INSTRUCTIONS}
                        component={ExamInstructions}
                    />
                    <ProtectedRoute
                        exact
                        path={navDirections.EXAMS_PAGE}
                        component={ExamPage}
                    />
                    <ProtectedRoute
                        exact
                        path={navDirections.EXAMS_INSTANT_RESULT}
                        component={ExamInstantResult}
                    />
                    <ProtectedRoute
                        exact
                        path={navDirections.EXAM_RESULTS}
                        component={Results}
                    />
                    <ProtectedRoute
                        exact
                        path={navDirections.EXAM_RANK_LIST}
                        component={RankList}
                    />
                    <ProtectedRoute
                        exact
                        path={navDirections.ATTENDANCE}
                        component={Attendance}
                    />
                    <ProtectedRoute
                        exact
                        path={navDirections.TIMETABLE}
                        component={Timetable}
                    />
                    <ProtectedRoute
                        exact
                        path={navDirections.ANNOUNCEMENTS}
                        component={Announcements}
                    />
                    <ProtectedRoute
                        exact
                        path={navDirections.CONTACT_US}
                        component={ContactUs}
                    />

                    <Route path={navDirections.ERROR} component={Error} />
                </Switch>
            </Container>
            {!!user && <BottomNav />}
        </Router>
    )
}

export default Main
